<template>
  <v-fade-transition>
    <v-layout v-if="qmps.length" justify-center>
      <v-flex shrink>
        <v-pagination v-model="page" :length="pagesLength" total-visible="10" />
      </v-flex>
    </v-layout>
  </v-fade-transition>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";

export default {
  computed: {
    ...mapGetters("matching", ["qmpsPage"]),
    ...mapState("matching", ["qmps", "qmpsFetch", "qmpsTotal"]),
    brand() {
      return this.$route.params.brandName;
    },
    classificationId() {
      return this.$route.params.classificationId;
    },
    page: {
      get() {
        return this.qmpsPage;
      },
      set(page) {
        return this.getQmps({
          brand: this.brand,
          classificationId: this.classificationId,
          page
        });
      }
    },
    pagesLength() {
      return Math.ceil(this.qmpsTotal / this.qmpsFetch);
    }
  },
  methods: {
    ...mapActions("matching", ["getQmps"])
  }
};
</script>